import React from 'react'
import c from "classnames";
import InputWrapper from "../../../lib/components/Forms/InputWrapper";

const spanBaseClasses = ['text-sm', 'font-bold', 'mb-1']

const spanDefaultClasses = ['text-gray-400']

const SpreedlyCreditCardInputs = ({ checkoutStore }) => {
  const spanClasses = [...spanBaseClasses, ...spanDefaultClasses, 'mt-5 block']
  const handleChangeMonth = (val) => checkoutStore.changeMonth(val.trim())
  const handleChangeYear = (val) => checkoutStore.changeYear(val.trim())

  return (<>
    <div className="w-full">
      <span className={c(spanClasses)}>Card Number*</span>
      <div id="spreedly-number" className="text-base h-11 p-2.5 rounded-md focus:ring-2 focus:outline-none transition-shadow text-gray-800 focus:ring-gray-600 focus:ring-opacity-20 bg-gray-50"></div>
    </div>
    <div className="flex">
      <div className="mr-4 mt-5">
        <InputWrapper label="Month*" placeholder="MM" inputStore={checkoutStore.month} onChange={handleChangeMonth} error={checkoutStore.month.errorMessage}/>
      </div>
      <div className="mr-4 mt-5">
        <InputWrapper label="Year*" placeholder="YYYY" inputStore={checkoutStore.year} onChange={handleChangeYear} error={checkoutStore.year.errorMessage} />
      </div>
      <div className="">
        <span className={c(spanClasses)}>CVV*</span>
        <div id="spreedly-cvv" className="text-base h-11 p-2.5 rounded-md focus:ring-2 focus:outline-none transition-shadow text-gray-800 focus:ring-gray-600 focus:ring-opacity-20 bg-gray-50"></div>
      </div>
    </div>
  </>)
}

export default SpreedlyCreditCardInputs
